var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","rounded":"","color":"red"},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":"/img/trash.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }